import WebApiService from "@/services/webapi.service.js";
import Reparto from "@/models/reparto.model.js";


const state = {
    reparti:[]
}

const getters = {

    getReparti: (state) => {      
        return state.reparti;
    },

    getDescrizioneReparti: (state) => (codiceReparto) => {
        if(state.reparti){
            let reparto = state.reparti.find(item => item.CodiceReparto === codiceReparto);

            if(reparto){
                return reparto.DescrizioneReparti ?? "-";
            }else{
                return "-";
            }
        }
        else{
            return "-";
        }
    }
}

const mutations = {

    setReparti: (state, reparti) => {
        state.reparti = reparti;      
    }
}

const actions = {

    getReparti: ({commit}, data) => {                                                                                                              
        return WebApiService.get('reparti/', data.token).then(
        (data) => {              
                if(data.StatusCode !== 200){
                    return [false, data.Message];
                }
                else{                  
                    commit("setReparti", data.Data.map(
                        o => { return Object.assign(new Reparto(), o) }
                    ));
                    return [true, ""];            
                }
            },
            error => {                      
               return [false, ""];
            }
        )
        .catch(
            error => {return [false, ""]}
        );
    }
}

export default{
    namespeced: true,
    state,
    getters,
    mutations,
    actions
}